import {
  getAuth,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  sendPasswordResetEmail,
  signOut,
  onAuthStateChanged,
} from "firebase/auth";

import app from "../config/firebaseConfig"; // firebase init
import { collection, getDocs, getFirestore, query, where } from "firebase/firestore";

// Get Firebase Auth Instance
const auth = getAuth(app);
const db = getFirestore(app);

// Check if email exists in admin collection
export const checkAdminEmail = async (email) => {
  try {
    const adminCollection = collection(db, 'admin');
    const q = query(adminCollection, where('email', '==', email));
    const querySnapshot = await getDocs(q);

    return !querySnapshot.empty; // Returns true if email exists in admin collection
  } catch (error) {
    console.error("Error checking admin email:", error);
    throw error;
  }
};


// Sign in service
export const signInService = async (email, password) => {
  try {
    const userCredential = await signInWithEmailAndPassword(auth, email, password);
    return { success: true, user: userCredential.user };
  } catch (error) {
    return { success: false, error: error.message };
  }
};

// Sign up service
export const signUpService = async (email, password) => {
  try {
    const userCredential = await createUserWithEmailAndPassword(auth, email, password);
    // You can update the user profile with firstName and lastName here if needed
    return { success: true, user: userCredential.user };
  } catch (error) {
    return { success: false, error: error.message };
  }
};

// Forgot password service
export const forgotPasswordService = async (email) => {
  try {
    await sendPasswordResetEmail(auth, email);
    return { success: true };
  } catch (error) {
    return { success: false, error: error.message };
  }
};

// Sign out service
export const signOutService = async () => {
  try {
    await signOut(auth);
    return { success: true };
  } catch (error) {
    return { success: false, error: error.message };
  }
};

// Check authentication state
export const checkAuthState = (callback) => {
  return onAuthStateChanged(auth, callback);
};